import ToolbarEmojiMenuTemplate from "./toolbar-emoji-menu.component.html"
import StorageService from "../../services/storage/storage.service"

class ToolbarEmojiMenuController {
  /**
   * @ngInject
   * @param {StorageService} StorageService
   */
  constructor(StorageService) {
    /** @type {StorageService} */
    this._storageService = StorageService
  }

  select(emoji) {
    this.onSelect({ emoji })
  }
}

export default {
  bindings: {
    emojis: "<",
    menuType: "@",
    onSelect: "&",
    transparentButtonText: "@",
  },
  template: ToolbarEmojiMenuTemplate,
  controller: ToolbarEmojiMenuController,
  controllerAs: "ctrl",
}
